import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
  ArrowLeft,
  Calendar,
  Clock,
  // User,
  Share2,
  Facebook,
  Twitter,
  Linkedin,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import NavBar from "@/components/woost/NavBar";
import Footer from "@/components/woost/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { StickyHeader } from "@/components/woost/StickyHeader";
import axios from "axios";

// const blogPosts = [
//   {
//     id: 1,
//     title: "7 Ways Nano-Influencers Drive Better ROI Than Celebrities",
//     excerpt:
//       "Learn why smaller creators often deliver better engagement and conversion rates for your campaigns.",
//     content: `
//       <p class="mb-6 text-lg">In today's digital marketing landscape, the allure of celebrity endorsements is increasingly being challenged by the authentic impact of nano-influencers. These smaller creators, typically with follower counts between 1,000 and 10,000, are proving to be marketing powerhouses for brands seeking genuine engagement and higher ROI.</p>

//       <h2 class="text-2xl font-bold mt-10 mb-4">Why Nano-Influencers Outperform Celebrities</h2>

//       <p class="mb-6">While celebrities can offer massive reach, nano-influencers provide something far more valuable in today's marketing environment: authenticity and trust. Their smaller, more dedicated audiences view them as peers rather than distant stars, leading to recommendations that feel like advice from a friend rather than a paid advertisement.</p>

//       <h3 class="text-xl font-bold mt-8 mb-3">1. Higher Engagement Rates</h3>

//       <p class="mb-6">Nano-influencers consistently achieve engagement rates of 4-8% compared to the 1-3% typically seen with celebrity accounts. This translates to more meaningful interactions per follower and a greater impact on consumer decision-making.</p>

//       <h3 class="text-xl font-bold mt-8 mb-3">2. Cost-Effective Campaigns</h3>

//       <p class="mb-6">For the price of one celebrity post, brands can activate dozens of nano-influencers. This diversification spreads your message across multiple niches and communities, reducing risk and increasing the chances of connecting with your ideal customers.</p>

//       <blockquote class="border-l-4 border-woost-yellow pl-4 italic my-8 text-lg">
//         "We saw a 300% increase in conversion rates when we shifted our budget from celebrity endorsements to a network of 50 nano-influencers in our target demographic." — Marketing Director at a leading D2C brand
//       </blockquote>

//       <h3 class="text-xl font-bold mt-8 mb-3">3. Authentic Content Creation</h3>

//       <p class="mb-6">Nano-influencers often create content that feels more genuine and relatable. Their photography, storytelling, and presentation typically align more closely with how their audience actually lives, rather than presenting an aspirational but unattainable lifestyle.</p>

//       <h3 class="text-xl font-bold mt-8 mb-3">4. Targeted Niche Audiences</h3>

//       <p class="mb-6">Many nano-influencers build their following around specific interests or expertise. This allows brands to tap into highly defined communities, whether it's sustainable fashion enthusiasts, vegan cooking fans, or tech early adopters.</p>

//       <h3 class="text-xl font-bold mt-8 mb-3">5. Higher Trust Factor</h3>

//       <p class="mb-6">Studies show that 70% of millennial consumers are influenced by recommendations from their peers. Nano-influencers operate in this peer-to-peer recommendation space, leveraging the trust they've built with their followers.</p>

//       <h3 class="text-xl font-bold mt-8 mb-3">6. Greater Willingness to Collaborate</h3>

//       <p class="mb-6">Smaller creators are often more flexible with campaign requirements and more enthusiastic about brand partnerships. They typically invest more effort in creating quality content and responding to audience questions about your products.</p>

//       <h3 class="text-xl font-bold mt-8 mb-3">7. Better Access to Regional Markets</h3>

//       <p class="mb-6">For brands looking to penetrate specific geographic markets, nano-influencers with local followings can provide authentic connections to communities that might otherwise be difficult to reach through traditional advertising.</p>

//       <h2 class="text-2xl font-bold mt-10 mb-4">How to Integrate Nano-Influencers Into Your Strategy</h2>

//       <p class="mb-6">The key to success with nano-influencers lies in building genuine relationships and allowing creative freedom. Here's how to start:</p>

//       <ul class="list-disc pl-6 mb-6">
//         <li class="mb-2">Identify creators whose authentic content style aligns with your brand values</li>
//         <li class="mb-2">Start with smaller collaborations to test engagement and fit</li>
//         <li class="mb-2">Provide clear guidelines but avoid overly restrictive creative briefs</li>
//         <li class="mb-2">Build long-term relationships rather than one-off campaigns</li>
//         <li class="mb-2">Track performance metrics beyond reach, focusing on engagement and conversion</li>
//       </ul>

//       <p class="mb-6">By embracing the power of nano-influencers, brands can create more authentic connections with their target audiences, drive higher engagement, and ultimately achieve a better return on their marketing investment.</p>
//     `,
//     imageUrl:
//       "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=800",
//     category: "Marketing Strategy",
//     date: "April 10, 2025",
//     author: {
//       name: "Priya Sharma",
//       role: "Marketing Specialist",
//       imageUrl:
//         "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200",
//     },
//     slug: "nano-influencers-vs-celebrities",
//     readTime: "6 min read",
//     tags: ["Influencer Marketing", "ROI", "Content Strategy", "Social Media"],
//     relatedPosts: [2, 3, 6],
//   },
//   {
//     id: 2,
//     title: "How to Create a Successful Barter Collaboration Strategy",
//     excerpt:
//       "Everything you need to know about running effective barter campaigns with creators on a limited budget.",
//     content: `<p>Content for "How to Create a Successful Barter Collaboration Strategy" goes here...</p>`,
//     imageUrl:
//       "https://images.unsplash.com/photo-1552581234-26160f608093?q=80&w=800",
//     category: "Barter Campaigns",
//     date: "April 5, 2025",
//     author: {
//       name: "Rahul Verma",
//       role: "Partnerships Lead",
//       imageUrl:
//         "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200",
//     },
//     slug: "barter-collaboration-strategy",
//     readTime: "8 min read",
//     tags: [
//       "Barter",
//       "Collaboration",
//       "Influencer Partnerships",
//       "Budget Marketing",
//     ],
//     relatedPosts: [1, 3, 5],
//   },
//   {
//     id: 3,
//     title: "UGC Content: The Secret Weapon for E-commerce Brands",
//     excerpt:
//       "Discover how user-generated content can dramatically improve your conversion rates and customer trust.",
//     content: `<p>Content for "UGC Content: The Secret Weapon for E-commerce Brands" goes here...</p>`,
//     imageUrl:
//       "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=800",
//     category: "UGC Strategy",
//     date: "March 28, 2025",
//     author: {
//       name: "Neha Kapoor",
//       role: "Content Strategist",
//       imageUrl:
//         "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200",
//     },
//     slug: "ugc-content-for-ecommerce",
//     readTime: "5 min read",
//     tags: ["UGC", "E-commerce", "Content Strategy", "Conversion Rate"],
//     relatedPosts: [1, 2, 4],
//   },
//   {
//     id: 4,
//     title: "The Future of Influencer Marketing in India",
//     excerpt:
//       "Key trends and predictions that will shape the creator economy in India over the next 5 years.",
//     content: `<p>Content for "The Future of Influencer Marketing in India" goes here...</p>`,
//     imageUrl:
//       "https://images.unsplash.com/photo-1579389083078-4e7018379f7e?q=80&w=800",
//     category: "Industry Trends",
//     date: "March 22, 2025",
//     author: {
//       name: "Vikram Singh",
//       role: "CEO & Founder",
//       imageUrl:
//         "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200",
//     },
//     slug: "future-of-influencer-marketing-india",
//     readTime: "7 min read",
//     tags: ["India", "Market Trends", "Creator Economy", "Future Predictions"],
//     relatedPosts: [1, 5, 6],
//   },
//   {
//     id: 5,
//     title: "How to Measure ROI on Your Influencer Campaigns",
//     excerpt:
//       "A comprehensive guide to tracking and measuring the true impact of your influencer marketing efforts.",
//     content: `<p>Content for "How to Measure ROI on Your Influencer Campaigns" goes here...</p>`,
//     imageUrl:
//       "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800",
//     category: "Analytics",
//     date: "March 15, 2025",
//     author: {
//       name: "Ananya Das",
//       role: "Analytics Lead",
//       imageUrl:
//         "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=200",
//     },
//     slug: "measuring-influencer-campaign-roi",
//     readTime: "9 min read",
//     tags: ["ROI", "Analytics", "Measurement", "Campaign Optimization"],
//     relatedPosts: [1, 2, 6],
//   },
//   {
//     id: 6,
//     title: "Creator Economy: Emergence of Nano and Micro Influencers",
//     excerpt:
//       "How small creators with highly engaged audiences are transforming the marketing landscape.",
//     content: `<p>Content for "Creator Economy: Emergence of Nano and Micro Influencers" goes here...</p>`,
//     imageUrl:
//       "https://images.unsplash.com/photo-1598257006458-087169a1f08d?q=80&w=800",
//     category: "Creator Economy",
//     date: "March 8, 2025",
//     author: {
//       name: "Arjun Mehta",
//       role: "Creator Relations",
//       imageUrl:
//         "https://images.unsplash.com/photo-1566492031773-4f4e44671857?q=80&w=200",
//     },
//     slug: "nano-micro-influencers-creator-economy",
//     readTime: "6 min read",
//     tags: [
//       "Creator Economy",
//       "Nano Influencers",
//       "Micro Influencers",
//       "Marketing Trends",
//     ],
//     relatedPosts: [1, 3, 4],
//   },
// ];

const BlogDetail: React.FC = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchData = async (): Promise<void> => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          "https://worker.woost.io/blog/wp-json/wp/v2/posts?slug=" +
            slug +
            "&_embed"
        );
        const data = await response.data;
        const post = data[0];
        setPost(post);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  const image_url = post?._embedded?.["wp:featuredmedia"][0]?.source_url;

  const istDate_top = new Date(post?.date).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
  });
  const [datePart, timePart] = istDate_top.split(", ");

  const parser = new DOMParser();
  const title_decoded = parser.parseFromString(
    post?.title?.rendered,
    "text/html"
  ).body.textContent;
  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />
      <StickyHeader />

      <div className="pt-28 pb-16">
        {/* Back button */}
        <div className="container mx-auto px-4 md:px-6 mb-8">
          <Button variant="outline" asChild>
            <Link to="/blog" className="flex items-center gap-2">
              <ArrowLeft size={16} />
              Back to Blog
            </Link>
          </Button>
        </div>

        {isLoading ? (
          <div className="text-4xl text-center min-h-[80vh] pt-36">
            loading...
          </div>
        ) : (
          <div className="container mx-auto px-4 md:px-6">
            <div className="max-w-4xl mx-auto mb-8">
              <div className="bg-woost-yellow/10 text-woost-yellow font-medium px-4 py-1 rounded-full inline-block mb-4">
                {post?.category}
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-gray-900 leading-tight">
                {title_decoded}
              </h1>

              <div className="flex flex-wrap items-center gap-6 mb-8 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <Calendar size={16} />
                  <span>{datePart}</span>
                </div>

                <div className="flex items-center gap-2">
                  <Clock size={16} />
                  <span className="uppercase">{timePart}</span>
                </div>

                {/* <div className="flex items-center gap-2">
                <User size={16} />
                <span>{post.author.name}</span>
              </div> */}
              </div>
            </div>

            {/* Featured image */}
            <div className="w-full h-64 md:h-[400px] lg:h-[500px] bg-gray-200 overflow-hidden mb-12 rounded-xl">
              <img
                src={image_url}
                alt={title_decoded}
                className="w-full h-full object-cover"
              />
            </div>

            <div>
              {/* Main content */}
              <div className="lg:col-span-8">
                <Card className="border-none shadow-md">
                  <CardContent className="p-8 md:p-10">
                    <div
                      className="artDetail_heading prose prose-lg max-w-none prose-headings:text-gray-800 prose-p:text-gray-600 prose-a:text-woost-blue prose-a:no-underline hover:prose-a:underline prose-blockquote:text-gray-800"
                      dangerouslySetInnerHTML={{
                        __html: post?.content?.rendered,
                      }}
                    />

                    {/* Tags */}
                    <div className="mt-10 pt-6 border-t border-gray-100">
                      <h4 className="text-sm font-medium mb-3 text-gray-700">
                        Tagged with:
                      </h4>
                      <div className="flex flex-wrap gap-2">
                        {post?.tags.map((tag) => (
                          <span
                            key={tag}
                            className="bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-700 hover:bg-gray-200 transition-colors cursor-pointer"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Share */}
                    <div className="mt-10 pt-6 border-t border-gray-100">
                      <h4 className="text-sm font-medium mb-3 flex items-center gap-2 text-gray-700">
                        <Share2 size={16} /> Share this article:
                      </h4>
                      <div className="flex gap-3">
                        <Button
                          variant="outline"
                          size="icon"
                          className="rounded-full h-10 w-10 hover:bg-gray-100 hover:text-woost-blue transition-colors"
                        >
                          <Facebook size={18} />
                        </Button>
                        <Button
                          variant="outline"
                          size="icon"
                          className="rounded-full h-10 w-10 hover:bg-gray-100 hover:text-woost-blue transition-colors"
                        >
                          <Twitter size={18} />
                        </Button>
                        <Button
                          variant="outline"
                          size="icon"
                          className="rounded-full h-10 w-10 hover:bg-gray-100 hover:text-woost-blue transition-colors"
                        >
                          <Linkedin size={18} />
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Author bio */}
                <Card className="border-none shadow-md mt-8">
                  <CardContent className="p-6 md:p-8">
                    <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
                      <img
                        src={post?.author.imageUrl}
                        alt={post?.author.name}
                        className="w-20 h-20 rounded-full object-cover ring-2 ring-gray-100"
                      />

                      <div>
                        <h3 className="text-xl font-bold mb-1 text-gray-900">
                          {post?.author.name}
                        </h3>
                        <p className="text-gray-600 mb-4">
                          {post?.author.role}
                        </p>
                        <p className="text-gray-700">
                          Expert in digital marketing and influencer strategies
                          with over 10 years of experience helping brands
                          connect with their audiences through authentic
                          content.
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* Sidebar */}
              {/* <div className="lg:col-span-4">
              {relatedPosts.length > 0 && (
                <Card className="border-none shadow-md sticky top-24">
                  <CardContent className="p-6">
                    <h3 className="text-lg font-bold mb-6 text-gray-900">
                      Related Articles
                    </h3>

                    <div className="space-y-6">
                      {relatedPosts.map((relatedPost) => (
                        <div key={relatedPost.id} className="group">
                          <Link
                            to={`/blog/${relatedPost.slug}`}
                            className="block"
                          >
                            <div className="mb-3 overflow-hidden rounded-lg">
                              <img
                                src={relatedPost.imageUrl}
                                alt={relatedPost.title}
                                className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
                              />
                            </div>

                            <h4 className="font-medium group-hover:text-woost-blue transition-colors line-clamp-2 text-gray-900">
                              {relatedPost.title}
                            </h4>

                            <div className="flex items-center gap-2 mt-2 text-sm text-gray-600">
                              <Clock size={14} />
                              <span>{relatedPost.readTime}</span>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>

                    <div className="mt-6 pt-6 border-t border-gray-100 text-center">
                      <Button
                        asChild
                        className="bg-woost-blue hover:bg-woost-blue-dark"
                      >
                        <Link to="/blog" className="w-full">
                          View All Articles
                        </Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )}
            </div> */}
            </div>
          </div>
        )}
      </div>

      {!post && (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">Post not found</h2>
            <Button asChild>
              <Link to="/blog">Back to Blog</Link>
            </Button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BlogDetail;
